import breakpoints from '../theme/breakpoints';
import { DIALOG_SIDE_PADDINGS } from '../theme/constants';

const styleOverrides = {
  root: {
    margin: 0,
    overflowY: 'visible',
    padding: `20px ${DIALOG_SIDE_PADDINGS.XS}`,
    [`@media only screen and (min-width: ${breakpoints.sm}px)`]: {
      padding: `24px ${DIALOG_SIDE_PADDINGS.SM}`,
    },
    '&:first-of-type': {
      paddingTop: '16px',
      [`@media only screen and (min-width: ${breakpoints.sm}px)`]: {
        paddingTop: '24px',
      },
    },
    '&:last-child': {
      paddingBottom: '16px',
      [`@media only screen and (min-width: ${breakpoints.sm}px)`]: {
        paddingBottom: '24px',
      },
    },
  },
};

export default styleOverrides;
